export class ITSUserData {
  public Name!: string;
  public Email!: string;
  public Title!: string;
  public Department!: string;
  public NtLogin!: string;
  public Image: any;
  public AccessToken: any;
  public IsDev!: string;
  public IsAdmin!: string;
  public UserAccess!: string;
  public IsSuperAdmin!: string;
}
export class TerritoryBudgetData {
  public uniqueid!: number;
  public lob!: string;
  public managerhcmid!: number;
  public territoryname!: string;
  public headcount!: number;
  public budgetedquota!: number;
  public lobcoverage!: number;
  public managercoverage!: number;
  public fiscalyear!: string;
  public quotacurrency!:string;
  public requestid!: number;
  public created!: Date;
  public createdby!: string;
  public updated!: Date;
  public updatedby!: string;
}
export class UploadResponseModel {
  public PresignedURL!: string;
  public RequestID!: number;
  public RequestType!: string;
  public FileName!: string;
  public Message!: string;
  public FileToUpload!: File;
}
export class UploadRequestModel {
  public uploadtypeid!: number;
  public fiscalyear!: string;
  public contenttype!: string;
  public userlogin!: string;
  public method!: string;
  public filename!: string;
}
export class DeleteObjectModel {
  public uniqueid!: number;
  public userlogin!: string;
}
export class StaffSecurityRoleData{
  public  securityroleid!:number ;
  public  staffid!:number; 
  public  emailaddress!:string ;
  public  createdby!:string ;
  public  securityroledescription!:string;
  public  created!:string;
  public uniqueid!: number;
  public active!:number;
}

export class QuotaInputData {
  public uniqueid!: number;
  public employeeid!:string;
  public employeename!: string;
  public variablepay!: number;
  public variablepaycurrency!: string;
  public planstartdate!: string;
  public variabletype!: string;
  public planenddate!: string;
  public lob!: string;
  public salesunit!: string;
  public plantype!: string;
  public territorygroup!: string;
  public totalquotausd!: number;
  public totalquota!: number;
  public fiscalyear!: string;
	public perpetualmultiplier!: number;
	public saasmultipliergt2lt3years!: number;
	public saasmultipliergt3years!: number;
  public saasmultipliergt1lt2years!: number;
	public perpetuallogomultiplier!: number;
	public saaslogomultiplier!: number;
  public gicrejected!: boolean;
  public commentsadded!: string;
	public detaileduniqueid!: number;
	public finaliseduniqueid!: number;
	public processed!: boolean;
  public created!: Date;
  public createdby!: string;
  public updated!: Date;
  public updatedby!: string;
  public nclbmultiplier!: number;
  public reprole!: string;
  public territorygroup2!: string;
  public territorygroup3!: string;
  public territorygroup4!: string;
  public territorygroup5!: string;
  public element2!: string;
  public paycurve2!: string;
  public totalquota2!: number;
  public element3!: string;
  public paycurve3!: string;
  public totalquota3!: number;
  public element4!: string;
  public paycurve4!: string;
  public totalquota4!: number;
  public element5!: string;
  public paycurve5!: string;
  public totalquota5!: number;
  public element1! :string;
  public paycurve1! :string;
  public q1_1! : number;
  public q2_1! : number;
  public q3_1! : number;
  public q4_1! : number;
  public q1_2! : number;
  public q2_2! : number;
  public q3_2! : number;
  public q4_2! : number;
  public q1_3! : number;
  public q2_3! : number;
  public q3_3! : number;
  public q4_3! : number;
  public q1_4! : number;
  public q2_4! : number;
  public q3_4! : number;
  public q4_4! : number;
  public q1_5! : number;
  public q2_5! : number;
  public q3_5! : number;
  public q4_5! : number;
  public q1_6! : number;
  public q2_6! : number;
  public q3_6! : number;
  public q4_6! : number;
}
export class DetailedQuotaData {
  public uniqueid!: number;
		public managername!: string;
		public managerid!: number;
		public employeeid!: string;
		public employeefirstname!: string;
		public employeelastname!: string;
		public lob!: string;
    public salesunit!: string;
		public perpetualmultiplier!: number;
		public saasmultipliergt2lt3years!: number;
		public saasmultipliergt3years!: number;
		public perpetuallogomultiplier!: number;
		public saaslogomultiplier!: number;
		public reprole!: string;
		public variabletype!: string;
		public holdrecord!: boolean;
		public plantype!: string;
		public variablepay!: number;
		public variablepaycurrency!: string;
		public perpetualquota!: number;
		public saaslt3yearquota!: number;
		public saasgt3yearquota!: number;
		public totalquota!: number;
		public fiscalyear!: string;
		public territorygroup!: string;
		public quotacurrency!: string;
		public countryname!: string;
		public functionalarea!: string;
		public department!: string;
		public departmentpercrm!: string;
		public requestid!: number;
		public employeestatus!: string;
		public employeestartdate!: Date;
		public prioryearplantype!: string;
		public prioryearquota!: number;
		public prioryearachievement!: number;
		public prioryearachievementpercent!: number;
		public prioryearcurrency!: string;
		public prioryearfxrate!: number;
		public currentyearfxrate!: number;
		public region!: string;
		public variablepayusd!: number;
		public prioryearquotausd!: number;
		public prioryearachievementusd!: number;
		public currentyearquotausd!: number;
		public localquotayoy!: number;
		public baserate!: number;
		public commentsadded!: string;
		public processed!: boolean;
		public created!: Date;
		public createdby!: string;
		public updated!: Date;
		public updatedby!: string;
		public nclbmultiplier!: number;
		public planstartdate!: string;
		public territorygroup2!: string;
		public territorygroup3!: string;
		public territorygroup4!: string;
		public territorygroup5!: string;
    public saasmultipliergt1lt2years!: number;
    public element2!: string;
    public paycurve2!: string;
    public totalquota2!: number;
    public element3!: string;
    public paycurve3!: string;
    public totalquota3!: number;
    public element4!: string;
    public paycurve4!: string;
    public totalquota4!: number;
    public element5!: string;
    public paycurve5!: string;
    public totalquota5!: number;
    public element1! :string;
    public paycurve1! :string;
    public q1_1! : number;
    public q2_1! : number;
    public q3_1! : number;
    public q4_1! : number;
    public q1_2! : number;
    public q2_2! : number;
    public q3_2! : number;
    public q4_2! : number;
    public q1_3! : number;
    public q2_3! : number;
    public q3_3! : number;
    public q4_3! : number;
    public q1_4! : number;
    public q2_4! : number;
    public q3_4! : number;
    public q4_4! : number;
    public q1_5! : number;
    public q2_5! : number;
    public q3_5! : number;
    public q4_5! : number;
    public q1_6! : number;
    public q2_6! : number;
    public q3_6! : number;
    public q4_6! : number;
}
export class RolePlanTypeMappingData {
  public uniqueid!: number;
  public roletype!: string;
  public plantype!: string;
  public created!: Date;
  public createdby!: string;
  public updated!: Date;
  public updatedby!: string;
}
export class RolePayCurveMappingData {
  public uniqueid!: number;
  public roletype!: string;
  public paycurve1!: string;
  public paycurve2!: string;
  public paycurve3!: string;
  public paycurve4!: string;
  public paycurve5!: string;
  public created!: Date;
  public createdby!: string;
  public updated!: Date;
  public updatedby!: string;
}
